export default {"src":"/_next/static/media/GILD.85d6210e.svg","height":18,"width":18};